export default __webpack_public_path__ + "static/footerGirl-67432affab592854bdf53d6c4d24ea7e.png";